import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

  users;

  constructor(private _http: HttpService, private route: ActivatedRoute) {
    console.log('In usre component');
    const id = this.route.snapshot.params['id'];
    console.log(id);
    this._http.getUsers(id).subscribe(
      (res) => {
        console.log(res);
        this.users = res;
      }
    );
  }

  ngOnInit() {

  }

}
